import * as featuredFeedActions from '../../action_creators/homepage/featured_feed_action_creators';
import FeaturedFeedModel from '../../../models/homepage/featured_module';
import log from '../../../services/logger_service';

export default function fetchFeaturedModule(params, store) {
  return function firstDispatchFeatured(dispatch) {
    dispatch(featuredFeedActions.featuredFeedLoading());
    return FeaturedFeedModel.fetch(params, store)
      .then(function handleFeaturedModuleData(resp) {
        dispatch(featuredFeedActions.featuredFeedLoaded(resp.data, store));
      })
      .catch(function handleFeaturedError(err) {
        dispatch(featuredFeedActions.featuredFeedLoadError(err, store));
        log.error(
          err,
          `Error in featured feed actions, message: ${err.message}`
        );
      });
  };
}
